module.exports = __webpack_public_path__ + "assets/img/ic-selfdefine.6ee03409.svg";